<template>
  <div class="reg-ate-time-line-msg" :class="(cpntStatus === '1' ? '' : ' celula-status-apagado') + (' ' + animacao)">
    <div class="celula" :class="('celula-' + cpntTipo)" :ref="'mensagem'" :style="[ 'responder', 'resposta' ].indexOf(cpntTipo) !== -1 ? ('padding-left: 15px; border-left: 3px solid ' +  usuario.cor_fundo) : ''" @click="regAteTimeLineMensagemFocusResposta(cpntChave)">
      <!-- MENU SUPSENSO DA MENSAGEM -->
      <div :key="time" class="opcoes-conteudo" v-if="mostrarOpcoes === true">
        <div class="mask" @click="regAteTimeLineMensagemOpcoes">&nbsp;</div>
        <div class="conteudo" :ref="'opcoes'">
          <ul>
            <li @click="regAteTimeLineMensagemDetalheMensagem">
              Dados da mensagem
            </li>
            <li @click="regAteTimeLineMensagemResponderMensagem(cpntId)">
              Responder
            </li>
            <li @click="regAteTimeLineMensagemFavorito(cpntId)">
              {{ [ '', null, undefined, '0' ].indexOf(cpntFavorito) === -1 ? 'Desfavoritar mensagem' : 'Favoritar mensagem' }}
            </li>
            <li v-if="cpntLastUser === $store.state.usuario.id_usu" @click="regAteTimeLineMensagemApagarMensagem">
              Apagar mensagem
            </li>
          </ul>
        </div>
      </div>

      <!-- OPÇÃO PARA ABRIR MENU SUSPENSO NA MENSAGEM -->
      <template v-if="cpntSetarResponder !== null">
        <div class="opcoes" @click="regAteTimeLineMensagemOpcoes" v-if="cpntStatus === '1' && [ 'responder' ].indexOf(cpntTipo) === -1">
          <i class="fas fa-chevron-down"></i>
        </div>
        <div class="opcoes" v-else-if="[ 'responder' ].indexOf(cpntTipo) !== -1" @click="regAteTimeLineMensagemResponderMensagem(null)">
          <i class="fa fa-times"></i>
        </div>
      </template>

      <div class="usuario" v-if="[ 'enviado' ].indexOf(cpntTipo) === -1 && Object.keys(usuario).length >= 1">
        <span :style="'font-weight: 600; color: ' + usuario.fundo + ';'" v-html="usuario.usuario"></span>
      </div>
      
      <Registro-Atendimento-Time-Line-Mensagem v-if="[ '', null, undefined ].indexOf(cpntMsgResposta) === -1 && Object.keys(cpntMsgResposta).length >= 1"
      :key="'resposta-' + time"
      :cpntChave="cpntChave + '--' + cpntId + '--' + cpntMsgResposta.id"
      :cpntTipo="'resposta'"
      :cpntId="cpntMsgResposta.id"
      :cpntMensagem="cpntMsgResposta.comentario"
      :cpntStatus="cpntMsgResposta.status"
      :cpntLastAt="cpntMsgResposta.last_at"
      :cpntLastUser="cpntMsgResposta.last_user"
      :cpntFiles="cpntMsgResposta.files"
      :cpntFormaContatoId="cpntMsgResposta.id_forma_contato"

      :cpntFormaConOptions="cpntFormaConOptions"

      :cpntSetarDetalhe="cpntSetarDetalhe"
      :cpntSetarFocusMsg="cpntSetarFocusMsg"
      ></Registro-Atendimento-Time-Line-Mensagem>

      <span class="noselect" v-if="cpntStatus !== '1'">
        <i class="fas fa-ban"></i>
        {{ cpntLastUser === $store.state.usuario.id_usu ? 'Você apagou essa mensagem' : 'Essa mensagem foi apagada' }}
      </span>
      <template v-else>
        <div class="mensagem">
          <table v-if="typeof mensagem !== 'string'" class="conexao_SuporteRF">
            <tr>
              <td rowspan="3" class="icone">
                <i class="fa fa-life-ring" title="Conexão SuporteRF"></i>
              </td>
              <td class="conteudo">
                O usuário <u><span v-html="mensagem.usuarioNome"></span></u> conectou com o SuporteRF com o seguinte motivo:
              </td>
            </tr>
            <tr>
              <td class="conteudo" style="padding-left: 10px;">
                <i class="fas fa-angle-double-right"></i>
                <span v-html="mensagem.motivo"></span>
              </td>
            </tr>
          </table>

          <span v-else>
            <span v-html="mensagem"></span>
          </span>
          <span style="width: 62px; display: inline-block;">&nbsp;</span>
        </div>
      
        <div class="files" v-if="Object.keys(files).length >= 1">
          <Armazenamento-Arquivos-Icone v-for="(arquivo, indexF) in files" :key="arquivo.id + '--' + indexF"
            :cpntId='arquivo.id'
            :cpntFileName='arquivo.filename'
            :cpntFileExt='arquivo.ext'
            :cpntFileSizeThumbnail='arquivo.size_bytes_thumbnail'
            :cpntThumbnail='arquivo.thumbnail_b64'
          ></Armazenamento-Arquivos-Icone>
        </div>

        <div class="hora" v-if="cpntTipo !== 'resposta'">
          <table>
            <tr>
              <td v-if="[ '', null, undefined, '0' ].indexOf(cpntFavorito) === -1">
                <svg class="fa fa-star" aria-hidden="true"></svg>
              </td>
              <td class="hora-icone" v-if="[ '', null, undefined ].indexOf(formaContato.icone) === -1">
                <i :class="formaContato.icone" :title="'Comunicação: ' + formaContato.nome"></i>
              </td>
              <td class="hora-texto">
                <span v-html="hora"></span>
              </td>
              <template v-if="[ '', null, undefined ].indexOf(cpntInteracao) === -1 && Object.keys(cpntInteracao).length >= 1">
                <td class="hora-icone" :class="cpntInteracao.tipo" :key="JSON.stringify(cpntInteracao)">
                  <span :class="cpntInteracao.class">
                    <svg class="fas fa-check" :title="cpntInteracao.title" :class="cpntInteracao.class"></svg>
                    <svg class="fas fa-check" :title="cpntInteracao.title" :class="cpntInteracao.class" v-if="cpntInteracao.tipo === 'dois'"></svg>
                  </span>
                </td>
              </template>
            </tr>
          </table>
        </div>
      </template>
    </div>

    <!-- DIV INCLUIDA PARA LIMPAR O FLOAT DO COMPONENT -->
    <div style="clear: both; width: 100%;"></div>
  </div>
</template>

<style scoped>
  .reg-ate-time-line-msg {
    width: 100%;
    min-width: 100%;
    max-width: 100%;

    margin: 0px;
    padding: 5px;
    position: relative;
  }
    .reg-ate-time-line-msg > .celula {
      max-width: 90%;
      max-width: 90%;
      border-radius: 5px;
      padding: 5px 10px;
    }
    .reg-ate-time-line-msg > .celula-recebido {
      border: 1px solid #dedede;
      background: #f4f3f6;
      color: #444;
      float: left;
    }
    .reg-ate-time-line-msg > .celula-enviado {
      border: 1px solid #8590a5;
      background: #7086af;
      color: #fff;
      float: right;
    }
    .reg-ate-time-line-msg > .celula-responder,
    .reg-ate-time-line-msg > .celula-resposta {
      border: 1px solid #a7a7a7;
      background: #e9e9e9;
      color: #444;
      width: 100%;
      min-width: 100%;
    }
    .reg-ate-time-line-msg > .celula-responder {
      min-width: initial;
      margin-left: 50px;
    }

    .celula-status-apagado > .celula-recebido {
      opacity: 0.65;
    }
    .celula-status-apagado > .celula-enviado {
      opacity: 0.75;
    }
      .reg-ate-time-line-msg > .celula > .reg-ate-time-line-msg {
        max-width: initial;
        cursor: pointer;
        opacity: 0.90;
        margin: 0px 0px 5px -16px;
        width: calc(100% + 32px);
        max-width: initial !important;
        min-width: initial !important;
      }
      .reg-ate-time-line-msg > .celula-enviado > .reg-ate-time-line-msg {
        margin-top: -11px;
        /* padding-right: 15px; */
      }
      .reg-ate-time-line-msg > .celula > .usuario {
        opacity: 0.55;
        font-size: 13px;
        margin-left: -8px;
        padding-right: 20px;
      }
      .reg-ate-time-line-msg > .celula > .mensagem > .conexao_SuporteRF  > tr > .conteudo > span,
      .reg-ate-time-line-msg > .celula > .mensagem {
        word-break: break-word;
        position: relative;
        white-space: pre-wrap;
        word-wrap: break-word;
      }
        .reg-ate-time-line-msg > .celula > .mensagem > span {
          white-space: pre-wrap;
          word-wrap: break-word;
        }
        .reg-ate-time-line-msg > .celula > .mensagem > .conexao_SuporteRF {
          width: 100%;
          padding: 0px;
          margin: 0px;
          text-align: left !important;
          word-break: initial;
          white-space: initial;
          word-wrap: initial;
        }
          .reg-ate-time-line-msg > .celula > .mensagem > .conexao_SuporteRF  > tr > td {
            padding: 0px;
            margin: 0px;
            vertical-align: top;
          }
          .reg-ate-time-line-msg > .celula > .mensagem > .conexao_SuporteRF  > tr > .icone {
            width: 35px;
            text-align: left;
            padding-right: 5px;
            font-size: 11px;
          }
            .reg-ate-time-line-msg > .celula > .mensagem > .conexao_SuporteRF  > tr > .icone > svg {
              font-size: 30px;
            }
          .reg-ate-time-line-msg > .celula > .mensagem > .conexao_SuporteRF  > tr > .conteudo {
            text-align: left;
          }
            .reg-ate-time-line-msg > .celula > .mensagem > .conexao_SuporteRF  > tr > .conteudo > span {
              font-size: 12px;
            }
            .reg-ate-time-line-msg > .celula > .mensagem > .conexao_SuporteRF  > tr > .conteudo > svg {
              font-size: 15px;
              margin-right: 5px;
              vertical-align: -3px;
            }
      .reg-ate-time-line-msg > .celula > .files {
        margin-bottom: 10px;
      }
      .reg-ate-time-line-msg > .celula > .hora {
        margin-top: -14px;
        margin-right: -10px;
        font-size: 11px;
        width: 70px;
        float: right;
        position: relative;
        bottom: -4px;
      }
      .reg-ate-time-line-msg > .celula-recebido > .hora {
        color: rgba(0, 0, 0, 0.45);
      }
      .reg-ate-time-line-msg > .celula-enviado > .hora {
        color: rgba(255, 255, 255, 0.60);
      }
        .reg-ate-time-line-msg > .celula > .hora > table {
          width: 100%;
        }
          .reg-ate-time-line-msg > .celula > .hora > table > tr > td {
            text-align: right;
            padding: 0px 1px;
          }
          .reg-ate-time-line-msg > .celula > .hora > table > tr > td.hora-icone {
            width: 20px;
            text-align: right !important;
          }
            .reg-ate-time-line-msg > .celula-recebido > .hora > table > tr > td.hora-icone > span.cor-normal > svg {
              color: #b2b2b2;
            }
            .reg-ate-time-line-msg > .celula-recebido > .hora > table > tr > td.hora-icone > span.cor-azul > svg {
              color: #81c1f7;
            }
            .reg-ate-time-line-msg > .celula-enviado > .hora > table > tr > td.hora-icone > span.cor-normal > svg {
              color: #c1cadc;
            }
            .reg-ate-time-line-msg > .celula-enviado > .hora > table > tr > td.hora-icone > span.cor-azul > svg {
              color: #69b6f3;
            }
            .reg-ate-time-line-msg > .celula > .hora > table > tr > td.um > span.cor-normal > svg {
              margin-right: 3px;
            }
            .reg-ate-time-line-msg > .celula > .hora > table > tr > td.dois > span.cor-normal > svg:last-child, 
            .reg-ate-time-line-msg > .celula > .hora > table > tr > td.dois > span.cor-normal > svg:last-child,
            .reg-ate-time-line-msg > .celula > .hora > table > tr > td.dois > span.cor-azul > svg:last-child, 
            .reg-ate-time-line-msg > .celula > .hora > table > tr > td.dois > span.cor-azul > svg:last-child {
              margin-top: -11px;
              margin-left: -4px;
            }

  .reg-ate-time-line-msg > .celula > .opcoes {
    margin-top: -18px;
    margin-right: -5px;
    float: right;
    cursor: pointer;
    display: none;
    position: relative;
    bottom: -13px;
    z-index: 10;
  }
  .reg-ate-time-line-msg > .celula-enviado > .opcoes {
    color: #fff;
  }
  .reg-ate-time-line-msg > .celula-recebido > .opcoes,
  .reg-ate-time-line-msg > .celula-responder > .opcoes,
  .reg-ate-time-line-msg > .celula-resposta > .opcoes {
    color: #999;
  }
  .reg-ate-time-line-msg > .celula:hover > .opcoes {
    display: block;
  }
    .reg-ate-time-line-msg > .celula > .opcoes-conteudo {
      position: relative;
    }
      .reg-ate-time-line-msg > .celula > .opcoes-conteudo > .mask {
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        z-index: 9999;
      }
      .reg-ate-time-line-msg > .celula > .opcoes-conteudo > .conteudo {
        position: fixed;
        left: -300px;
        top: -300px;
        border: 1px solid #ccc;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 10px 1px rgba(0,0,0,0.3);
        -moz-box-shadow: 10px 10px 10px 1px rgba(0,0,0,0.3);
        box-shadow: 10px 10px 10px 1px rgba(0,0,0,0.3);
        font-weight: normal;
        padding: 5px 10px;

        background-color: #fff;
        border-radius: 5px;
        padding: 5px;

        width: 200px;
        margin-top: 10px;
        z-index: 10000;
      }
      .reg-ate-time-line-msg > .celula-recebido > .opcoes-conteudo > .conteudo {
        right: 0px;
      }
      .reg-ate-time-line-msg > .celula-enviado > .opcoes-conteudo > .conteudo {
        left: 0px;
      }

      .reg-ate-time-line-msg > .celula > .opcoes-conteudo > .conteudo > ul {
        list-style: none;
        margin-bottom: 0px;
        color: #444;
        width: 100%;
        padding: 0px;
      }
        .reg-ate-time-line-msg > .celula > .opcoes-conteudo > .conteudo > ul > li {
          width: 100%;
          padding: 5px 5px 5px 30px;
          border: 1px solid #fff;
          cursor: pointer;
        }
        .reg-ate-time-line-msg > .celula > .opcoes-conteudo > .conteudo > ul > li:hover {
          background: #f9f9f9;
          border: 1px solid #ccc;
          border-top: 1px solid #ccc;
          border-bottom: 1px solid #ccc;
        }

.animacao-focus {
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.10);
}
</style>

<style>
.reg-ate-time-line-msg > .celula > .reg-ate-time-line-msg > .celula {
  border-color: #d0d0d0;
  border-radius: 0px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  /* border-bottom-left-radius: 5px; */
}
  .reg-ate-time-line-msg > .celula > .reg-ate-time-line-msg > .celula > .files {
    margin-bottom: 0px;
    /* margin: 2px; */
  }
    .reg-ate-time-line-msg > .celula > .files > .cpnt-arm-arq-icone {
      border-radius: 5px;
      padding: 5px !important;
      margin: 2px !important;
    }

    .reg-ate-time-line-msg > .celula > .files > .cpnt-arm-arq-icone:hover {
      background: #e9e9e9;
    }
</style>

<script>
  export default {
    name: 'Registro-Atendimento-Time-Line-Mensagem',
    props: {
      cpntTipo: {
        require: true,
        type: String,
        validator: function (val) { return ([ 'responder', 'resposta', 'enviado', 'recebido' ].indexOf(val) !== -1) }
      },
      cpntId: {
        require: true
      },
      cpntChave: {
        require: true
      },
      cpntMensagem: {
        require: true,
        type: String
      },
      cpntFormaContatoId: {
        require: true,
        type: String
      },
      cpntMsgResposta: {
        require: false,
        default: function () {
          return null
        }
      },
      cpntInteracao: {
        require: false,
        default: function () {
          return null
        }
      },
      cpntStatus: {
        require: true
      },
      cpntLastAt: {
        require: true,
        type: String
      },
      cpntFavorito: {
        require: true,
        type: String
      },
      cpntLastUser: {
        require: true,
        type: String
      },
      cpntFiles: {
        require: false,
        type: Object,
        default: function () {
          return {}
        }
      },
      cpntFormaConOptions: {
        require: false,
        type: Array,
        default: function () {
          return []
        }
      },

      cpntSetarResponder: {
        require: true,
        default: function () {
          return null
        }
      },
      cpntSetarFocusMsg: {
        require: true,
        default: function () {
          return null
        }
      },
      cpntSetarDetalhe: {
        require: true
      }
    },
    components: {
      'Armazenamento-Arquivos-Icone': () => import('@/components/armazenamento-arquivos/Armazenamento-Arquivos-Icone.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        mensagem: '',
        hora: '',
        usuario: {},
        files: [],
        formaContato: {},
        mostrarOpcoes: false,
        animacao: ''
      }
    },
    mounted: function () {
      this.regAteTimeLineMensagemIniciar()

      // FALTA MOSTRAR O REGISTRO
      // FALTA RECEBER WEBSOCKET
    },
    methods: {
      regAteTimeLineMensagemIniciar: function () {
        // CHAMA A FUNÇÃO PARA CONVERTER A MENSAGEM
        this.regAteTimeLineMensagemConverteMenagem()
        
        // CHAMA A FUNÇÃO PARA MONTAR A HORA
        this.regAteTimeLineMensagemMontarHora()

        // CHAMA A FUNÇÃO PARA SETAR OS DADOS DO USUARIO
        this.regAteTimeLineMensagemSetarFormaContato()

        // CHAMA A FUNÇÃO PARA SETAR OS DADOS DO USUARIO
        this.regAteTimeLineMensagemSetarDadosUsuario()

        // CHAMA A FUNÇÃO PARA CONVERTER E TRATAR OS ARQUIVOS RECEBIDOS
        this.regAteTimeLineMensagemConverterChavesFiles()
      },
      regAteTimeLineMensagemSetaStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      regAteTimeLineMensagemOpcoes: function () {
        // SETA O CAMPO SE DEVE OU NÃO MOSTRAR
        this.mostrarOpcoes = !this.mostrarOpcoes

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
        
        // VERIFICA SE TEM QUE CALCULAR A POSIÇÃO
        if (this.mostrarOpcoes === true) {
          this.regAteTimeLineMensagemCalcularPosicao()
        }
      },
      regAteTimeLineMensagemCalcularPosicao: function (tentativa = 0, repete = 0, self = null) {
        // SETA A VARIAVEL SE ELA NÃO FOI DEFINIDA
        if (self === null) {
          self = this
        }

        // AGUARDA ALGUNS SEGUNDOS
        setTimeout(function () {
          if (repete <= 4) {
            // INICIA A CHAVE QUE DEVE BUSCAR
            var msg = 'mensagem'
            var opcoes = 'opcoes'

            if ([ '', null, undefined ].indexOf(self.$refs[opcoes]) === -1 && [ '', null, undefined ].indexOf(self.$refs[msg]) === -1) {
              // PEGA AS POSSIÇÕES DO CAMPO
              var offsetMensagem = self.$refs[msg].getBoundingClientRect()
              var offsetOpcoes = self.$refs[opcoes].getBoundingClientRect()

              // ADICIONA A POSIÇÃO
              self.$refs[opcoes].style.left = (offsetMensagem.right - offsetOpcoes.width)
              self.$refs[opcoes].style.top = (offsetMensagem.top - (offsetOpcoes.height + 10))

              // CHAMA A FUNÇÃO PARA REPETIR NOVAMENTE O CALCULO DO TAMANHO
              self.regAteTimeLineMensagemCalcularPosicao(tentativa, (repete + 1), self)
            } else if (tentativa <= 10) {
              self.regAteTimeLineMensagemCalcularPosicao((tentativa + 1), repete, self)
            }
          }
        }, (tentativa === 0 && repete === 0 ? 0 : 100))
      },
      regAteTimeLineMensagemConverteMenagem: function () {
        // VERIFICA SE É UMA CONEXÃO DO SUPORTE RF E CONVERTE EM VETOR O VALOR RECEBIDO
        if ([ '', null, undefined ].indexOf(this.cpntMensagem) === -1 && this.cpntMensagem.indexOf('CONECTAR_SUPORTE_RF') !== -1) {
          this.mensagem = JSON.parse(this.cpntMensagem)
        } else {
          switch ([ '', null, undefined ].indexOf(this.cpntMensagem) === -1) {
            case true:
              // CONVERTE OS LINKS RECEBIDOS
              // eslint-disable-next-line
              this.mensagem = this.cpntMensagem.replace(/(<a href=")?((https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)))(">(.*)<\/a>)?/gi, function () { return '<a href="' + arguments[2] + '" target="_blank">' + (arguments[7] || arguments[2]) + '</a>' })
              break
  
            default:
              this.mensagem = ''
              break
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      regAteTimeLineMensagemSetarFormaContato: function () {
        switch ([ '', null, undefined ].indexOf(this.cpntFormaContatoId) === -1) {
          case true:
            // PEGA OS DADOS DO USUARIO
            var formaContato = this.cpntFormaConOptions.filter(item => item.id === this.cpntFormaContatoId)

            // PEGA OS DADOS ENCONTRADOS
            this.formaContato = formaContato.length >= 1 ? formaContato[0] : {}
            break

          default:
            this.formaContato = {}
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      regAteTimeLineMensagemSetarDadosUsuario: function () {
        switch ([ '', null, undefined ].indexOf(this.cpntLastUser) === -1) {
          case true:
            // PEGA OS DADOS DO USUARIO
            var user = this.$store.state.usuarios_reg_ate.filter(item => item.id === this.cpntLastUser)

            // VERIFICA SE O USUARIO FOI ENCONTRADO
            if (user.length === 0) {
              // PEGA OS DADOS DO USUARIO DO VETOR MASTER
              user = this.$store.state.usuarios.filter(item => item.id === this.cpntLastUser)

              // VERIFICA SE O USUARIO FOI ENCONTRADO
              if (user.length !== 1) {
                user[0] = Object.assign(user[0], { fundo: 'rgb(64, 148, 169)', letra: 'rgb(255, 255, 255) !important', borda: '1px solid rgba(64, 148, 169, 0.6)', inicial: ' ' })
              }
            }

            // PEGA OS DADOS ENCONTRADOS
            this.usuario = user.length >= 1 ? user[0] : {}
            break

          default:
            this.usuario = {}
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      regAteTimeLineMensagemMontarHora: function () {
        switch ([ '', null, undefined ].indexOf(this.cpntLastAt) === -1) {
          case true: {
            // IMPORTA BIBLIOTECA DEPENDENTE
            var moment = require('moment')

            // FORMATA A DATA RECEBIDA
            var data_hora = moment(this.cpntLastAt, 'YYYY-MM-DD HH:mm:ss')
    
            // FORMATA A DATA RECEBIDA
            var last_at_ptbr = data_hora.format('DD/MM/YYYY HH:mm:ss')
            last_at_ptbr = last_at_ptbr.split(' ').join(' às ')

            // IMPORTA A FUNÇÃO PARA ATUAIZAR OS DADOS DA API
            const FUN_PEGAR_HORA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_HORA
            
            // SETA A HORA DA MENSAGEM
            this.hora = FUN_PEGAR_HORA(last_at_ptbr, true)
            break
          }

          default:
            this.hora = ''
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      regAteTimeLineMensagemConverterChavesFiles: function () {
        switch ([ '', null, undefined ].indexOf(this.cpntFiles) === -1) {
          case true:
            // SETA A HORA DA MENSAGEM
            var objetos = {}

            // CONVERTE AS CHAVES RECEBIDAS
            for (var key in this.cpntFiles) {
              // INICIA O VETOR
              objetos[key] = {}

              // RODA FOR PARA ADICIONAR AS CHAVES
              for (var chave in this.cpntFiles[key]) {
                switch (chave) {
                  case 'id':
                    objetos[key].id = this.cpntFiles[key][chave]
                    break

                  case 'name':
                  case 'filename':
                    objetos[key].filename = this.cpntFiles[key][chave]
                    break

                  case 'ext':
                    objetos[key].ext = this.cpntFiles[key][chave]
                    break

                  case 'size_bytes_thumbnail':
                    objetos[key].size_bytes_thumbnail = this.cpntFiles[key][chave]
                    break

                  case 'thumbnail_b64':
                    objetos[key].thumbnail_b64 = this.cpntFiles[key][chave]
                    break

                  // default:
                  //   this.$store.state.msgWarn('WEB [409]: Erro ao converter a chave (' + chave + ').', 'danger')
                  //   break
                }
              }
            }
    
            // SETA A HORA DA MENSAGEM
            this.files = objetos
            break

          default:
            this.files = ''
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      regAteTimeLineMensagemDetalheMensagem: function () {
        // CHAMA A FUNÇÃO PARA FECHAR AS OPÇÕES
        this.regAteTimeLineMensagemOpcoes()

        // CHAMA A FUNÇÃO PARA ABRIR O RESPONDER
        this.cpntSetarDetalhe(this.cpntId)
      },
      regAteTimeLineMensagemResponderMensagem: function (id) {
        // CHAMA A FUNÇÃO PARA FECHAR AS OPÇÕES
        this.regAteTimeLineMensagemOpcoes()

        // CHAMA A FUNÇÃO PARA ABRIR O RESPONDER
        this.cpntSetarResponder(id)
      },
      regAteTimeLineMensagemApagarMensagem: function () {
        var self = this

        // CHAMA A FUNÇÃO PARA FECHAR AS OPÇÕES
        self.regAteTimeLineMensagemOpcoes()

        if (window.confirm('Deseja realmente excluir está mensagem?')) {
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // MONTA O FORMULARIO QUE SERÁ ENVIADO PARA API
          var formData = { lot: [ { id: self.cpntId } ] }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          self.$store.state.comunicaAPI('/reg-atendimento', 'DELETE', formData, function (apiSuccess) {
            self.$store.state.TRATAR_RET_LOT_API(apiSuccess)
          }, self.regAteTimeLineMensagemSetaStatusGeral)
        }
      },
      regAteTimeLineMensagemFocusResposta: function (id) {
        // PEGA OS DADOS RECEBIDOS
        var index = id.split('--')
        
        // VERIFICA SE DEVE CHAMAR A FUNÇÃO PARA DAR FOCUS
        if (index.length === 3 && [ '', null, undefined ].indexOf(this.cpntSetarFocusMsg) === -1) {
          this.cpntSetarFocusMsg(index[0], index[1])
        }
      },
      regAteTimeLineMensagemRealizarFocus: function (scroll, self = null, tentativa = 0, repete = 0) {
        if (tentativa <= 10 && repete <= 2) {
          // INICIA A VARIAVEL SELF
          if ([ '', null, undefined ].indexOf(self) !== -1) {
            self = this
          }

          // VERIFICA SE FOI ENCONTRADO A MENSAGEM
          if ([ '', null, undefined ].indexOf(self.$refs) !== -1 || [ '', null, undefined ].indexOf(self.$refs.mensagem) !== -1) {
            setTimeout(function () { self.regAteTimeLineMensagemRealizarFocus(scroll, self, (tentativa + 1)) }, 500)
          } else {
            // REALIZA O SCROOL E DA FOCUS NA MENSAGEM
            self.$refs.mensagem.scrollIntoView(true)

            // PEGA UMA DIFERENÇA DO SCROLL
            // scroll.scrollTop = (scroll.scrollTop - 40) > 0 ? scroll.scrollTop - 40 : 0

            // VERIFICA SE A CLASSE JÁ EXISTE
            if (self.animacao !== 'animacao-focus') {
              self.animacao = 'animacao-focus'
            }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
            
            // REPTE A FUNÇÃO PARA POSICIONAR CERTO
            setTimeout(function () { self.regAteTimeLineMensagemRealizarFocus(scroll, self, tentativa, (repete + 1)) }, 100)
          }
        } else {
          setTimeout(function () {
            // REMOVE AS CLASSES DE ANIMAÇÃO
            self.animacao = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }, 2000)
        }
      },
      regAteTimeLineMensagemFavorito: function () {
        var self = this

        // CHAMA A FUNÇÃO PARA FECHAR AS OPÇÕES
        self.regAteTimeLineMensagemOpcoes()

        // MONTA O FORMULARIO QUE SERÁ ENVIADO PARA API
        var formData = { j_id: JSON.stringify([ self.cpntId ]) }

        // SETA A ROTA QUE DEVE UTILIZAR
        var route = [ '', null, undefined, '0' ].indexOf(self.cpntFavorito) === -1 ? '/reg-atendimento/desfavoritar' : '/reg-atendimento/favoritar'

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        self.$store.state.comunicaAPI(route, 'PUT', formData, self.$store.state.TRATAR_RET_LOT_API, self.regAteTimeLineMensagemSetaStatusGeral, function (apiValid, apiStatus) {
          self.$store.state.FUN_API_RET_VALIDA(self, 'formulario', apiValid, apiStatus, {}, true, null)
        })
      }
    },
    watch: {
      cpntMensagem: function () {
        this.regAteTimeLineMensagemConverteMenagem()
      },
      cpntLastUser: function () {
        this.regAteTimeLineMensagemSetarDadosUsuario()
      },
      cpntLastAt: function () {
        this.regAteTimeLineMensagemMontarHora()
      },
      cpntFiles: function () {
        this.regAteTimeLineMensagemConverterChavesFiles()
      }
    }
  }
</script>
